import { crossAppConfig } from '../../config';

export const connectCarrierConfig = crossAppConfig;
